<template>
    <Tabs
        v-if="id"
        ref="Tabs"
        :form="form"
        :model="model"
    />

    <Wizard
        v-else
        ref="Wizard"
        :form="form"
        :model="model"
        @finish="save"
    />
</template>

<script>
// Components.
import Tabs from './Tabs'
import Wizard from './Wizard'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, unmask, stringCase, object } from '@/mixins'

export default {
    components: { Tabs, Wizard },
    mixins: [ repository, error, unmask, stringCase, object ],
    props: {
        id: { type: Number }
    },
    data: () => ({
        repositories: {
            unidade: null,
        },
        form: {
            termosInvalidos: [],
            oldCnpj: '',
            dadosAdministrativos: {
                tipos: [],
                esferasAdministrativas: [],
                naturezasJuridicas: [],
                autocompleteFields: {
                    gestor: [
                        { key: 'cadastroCidadao.nome', searchable: true },
                    ],
                },
            },
            infraestruturas: {
                estados: [],
                zonas: [],
                autocompleteFields: {
                    municipio: [
                        { key: 'nome', searchable: true },
                    ],
                    logradouro: [
                        { key: 'tipo.descricao', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                },
                unidades: [],
            },
        },
        model: {
            id: null,
            cnpj: null,
            nomeFantasia: null,
            razaoSocial: null,
            site: null,
            email: null,
            tipoId: null,
            esferaAdministrativaId: null,
            gestor: null,
            naturezaJuridicaId: null,
            cnes: '',
            pertenceSus: true,
            unidadeReferencia: false,
            unidadePrestadora: false,
            infraestruturas: [],
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.unidade.edit(this.id)
                : this.repositories.unidade.create()

            request
                .then(({ data }) => {

                    this.form.termosInvalidos = data.form.termosInvalidos

                    Object.assign(this.form.dadosAdministrativos, data.form.dadosAdministrativos)
                    Object.assign(this.form.infraestruturas, data.form.infraestruturas)

                    if (data.model) {

                        this.model.id = this.id
                        this.form.oldCnpj = data.model.cnpj

                        Object.assign(this.model, data.model)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs[this.id ? 'Tabs' : 'Wizard'].validate()
                .then(valid => {

                    if (!valid) return

                    if (!this.model.cnpj || this.model.cnpj === this.form.oldCnpj) {

                        this.handleSave()

                        return
                    }

                    this.setLoading()

                    this.repositories.unidade.index({ cnpj: this.unMaskCnpj(this.model.cnpj) })
                        .then(({ data }) => {

                            if (data.length > 0) {

                                this.showConfirmation(
                                    'Este CNPJ já está em uso. Deseja continuar?',
                                    async () => this.handleSave(),
                                    async () => {

                                        this.model.cnpj = ''

                                        this.$refs[this.id ? 'Tabs' : 'Wizard'].goToDadosTab()
                                    }
                                )

                                return
                            }

                            this.handleSave()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleSave() {

            this.setLoading()

            const request = this.id
                ? this.repositories.unidade.update(this.id, this.prepareData())
                : this.repositories.unidade.store(this.prepareData())

            request
                .then(({ data }) => {

                    this.showSaveNotification()
                    this.$emit('save', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const unidade = this.clone(this.model)

            delete unidade.id

            if (unidade.cnpj) {

                unidade.cnpj = this.unMaskCnpj(unidade.cnpj)
            }

            unidade.gestorId = unidade.gestor && unidade.gestor.id ? unidade.gestor.id : null;

            delete unidade.gestor

            unidade.infraestruturas = unidade.infraestruturas.map(infraestrutura => {

                infraestrutura.telefone = this.unMaskPhone(infraestrutura.telefone)
                infraestrutura.endereco.logradouroId = infraestrutura.endereco.logradouro.id

                delete infraestrutura.endereco.estadoId
                delete infraestrutura.endereco.municipio
                delete infraestrutura.endereco.logradouro
                delete infraestrutura.endereco.bairroNome
                delete infraestrutura.endereco.cep

                infraestrutura.centrosCusto = infraestrutura.centrosCusto.map(centroCusto => {

                    delete centroCusto.setorNome

                    return centroCusto
                })

                return infraestrutura
            })

            return this.camelObjectKeysToSnakeRecursive(unidade)
        },
    },
    created() {

        this.repositories.unidade = this.getConectaSusRepository('cadastro.estabelecimento.unidade')

        this.load()
    },
}
</script>